import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import {
  getNotifications,
  NotificationFilters,
} from '@/features/notifications/api/get-notifications';
import { useNotificationHubFilterStore } from '@/features/notifications/components/notification-hub-filter';
import { useCurrentOrg } from '@/features/org/hooks/use-org';

type Props = {} & UseQueryOptions<
  Awaited<ReturnType<typeof getNotifications>>,
  unknown
>;

export const getNotificationsQueryKey = (orgId?: number) => [
  'notifications',
  orgId,
];

export const useNotifications = (props?: Props) => {
  const { data: org, isLoading } = useCurrentOrg();

  const {
    partnerIds,
    projectIds,
    subprojectIds,
    roles,
    fromDate,
    toDate,
    notificationTypes,
    notificationStatuses,
    notificationCategories,
  } = useNotificationHubFilterStore();

  const filters = {
    notificationTypes,
    notificationStatuses,
    notificationCategories,
    partnerIds,
    projectIds,
    subprojectIds,
    projectRoles: roles,
    fromDate,
    toDate,
  } as NotificationFilters;

  return useQuery({
    ...props,
    queryKey: [...getNotificationsQueryKey(org?.id), filters],
    enabled: !isLoading && !!org,
    queryFn: () => {
      if (!org || isLoading) {
        return [];
      }

      return getNotifications(org.id, filters);
    },
  });
};
